export default function WhyTrainingsFail() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const traditionalSteps = [
    'Тренинг',
    'Воодушевление',
    'Через неделю всё забыли',
    'Работают как раньше',
  ];

  const expertSteps = [
    { label: 'Диагностика', desc: 'Анализ текущих показателей, воронки, конверсии' },
    { label: 'Изучение бизнеса', desc: 'Погружение в продукт, рынок, специфику компании' },
    { label: 'Прослушивание звонков', desc: 'Аудит реальных разговоров менеджеров' },
    { label: 'Анализ переписок', desc: 'Оценка качества деловой переписки и КП' },
    { label: 'Интервью', desc: 'Беседы с сотрудниками и руководителями' },
    { label: 'Программа', desc: 'Разработка индивидуальной программы обучения' },
    { label: 'Практический тренинг', desc: '80% практики на реальных кейсах компании' },
    { label: 'Реальные кейсы', desc: 'Отработка на задачах из ежедневной работы' },
    { label: 'Сопровождение', desc: 'Поддержка внедрения изменений 1–6 месяцев' },
    { label: 'Рост показателей', desc: 'Измеримые результаты: конверсия, чек, прибыль' },
  ];

  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Почему большинство <strong>тренингов по продажам</strong> не работают
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Тренинг сам по себе не меняет продажи. Продажи меняет система: диагностика → обучение → внедрение → сопровождение. Сравните два подхода.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Traditional model */}
          <div className="bg-white rounded-2xl p-6 md:p-8 border-2 border-red-100">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-close-circle-line text-2xl text-red-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900">Большинство компаний</h3>
                <p className="text-sm text-gray-500">Стандартный подход</p>
              </div>
            </div>

            <div className="relative">
              {traditionalSteps.map((step, i) => (
                <div key={i} className="flex items-start gap-4 mb-0">
                  <div className="flex flex-col items-center flex-shrink-0">
                    <div className="w-10 h-10 bg-red-50 border-2 border-red-200 rounded-full flex items-center justify-center text-sm font-bold text-red-600">
                      {i + 1}
                    </div>
                    {i < traditionalSteps.length - 1 && (
                      <div className="w-0.5 h-10 bg-red-200"></div>
                    )}
                  </div>
                  <div className="pb-6 pt-1.5">
                    <p className="text-gray-700 font-medium">{step}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-4 bg-red-50 rounded-lg p-4 text-center">
              <p className="text-red-700 font-semibold text-sm">Результат: деньги потрачены, продажи не выросли</p>
            </div>
          </div>

          {/* Expert model */}
          <div className="bg-white rounded-2xl p-6 md:p-8 border-2 border-teal-200">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-check-line text-2xl text-teal-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900">Мой подход</h3>
                <p className="text-sm text-gray-500">Системная работа на результат</p>
              </div>
            </div>

            <div className="relative">
              {expertSteps.map((step, i) => (
                <div key={i} className="flex items-start gap-4 mb-0">
                  <div className="flex flex-col items-center flex-shrink-0">
                    <div className="w-10 h-10 bg-teal-50 border-2 border-teal-200 rounded-full flex items-center justify-center text-sm font-bold text-teal-600">
                      {i + 1}
                    </div>
                    {i < expertSteps.length - 1 && (
                      <div className="w-0.5 h-6 bg-teal-200"></div>
                    )}
                  </div>
                  <div className="pb-4 pt-1.5">
                    <p className="text-gray-900 font-semibold">{step.label}</p>
                    <p className="text-sm text-gray-500">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-4 bg-teal-50 rounded-lg p-4 text-center">
              <p className="text-teal-700 font-semibold text-sm">Результат: измеримый рост показателей отдела продаж</p>
            </div>
          </div>
        </div>

        <div className="text-center mt-10">
          <button
            onClick={() => scrollTo('contact')}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Хочу системный подход
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}